import PageHeader from "../components/PageHeader";
import BookingForm from "../components/BookingForm";
import Reveal from "../components/Reveal";
import { CONTACT } from "../data/site";

export default function Reservation() {
  return (
    <div data-testid="page-reservation">
      <PageHeader
        overline="Réservation & devis"
        title="Composons "
        italicWord="votre vol."
        lead="Renseignez ci-dessous votre demande. Nous revenons vers vous sous 24–48 h avec les disponibilités et, si nécessaire, un devis dédié."
      />

      <section className="py-16 md:py-24 bg-[color:var(--bs-bg)]">
        <div className="mx-auto max-w-[1440px] px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-8">
            <BookingForm />
          </div>
          <aside className="lg:col-span-4 lg:sticky lg:top-28 lg:h-fit">
            <Reveal>
              <div className="border border-black/10 p-8 bg-[color:var(--bs-cream)]">
                <div className="overline text-[color:var(--bs-muted)]">
                  Une préférence ?
                </div>
                <h3 className="mt-4 font-display text-3xl font-light">
                  Appelez-nous.
                </h3>
                <p className="mt-4 text-[color:var(--bs-muted)] font-light text-sm leading-relaxed">
                  Nos équipes vous répondent directement et composent votre vol
                  au téléphone.
                </p>
                <a
                  data-testid="reservation-phone"
                  href={`tel:${CONTACT.phoneRaw}`}
                  className="mt-6 inline-block font-display text-3xl font-light text-[color:var(--bs-ink)]"
                >
                  {CONTACT.phone}
                </a>
                <div className="mt-8 border-t border-black/10 pt-6 space-y-3 text-sm">
                  <div>
                    <div className="overline text-[color:var(--bs-muted)]">Email</div>
                    <a
                      href={`mailto:${CONTACT.email}`}
                      className="mt-1 block link-underline text-[color:var(--bs-ink)]"
                      data-testid="reservation-email"
                    >
                      {CONTACT.email}
                    </a>
                  </div>
                  <div>
                    <div className="overline text-[color:var(--bs-muted)]">Base</div>
                    <div className="mt-1 text-[color:var(--bs-ink)]">
                      {CONTACT.base}
                    </div>
                  </div>
                </div>
              </div>
            </Reveal>
          </aside>
        </div>
      </section>
    </div>
  );
}
